import type { RouteObject } from 'react-router-dom'

import {
	type LeftSide,
	leftSideActions
} from '@appStore/reducers/leftSideMenu.ts'
import store from '@appStore/store.ts'
import accountSvg from 'assets/image/icons/svg/account.svg'
import pageIcon from 'assets/image/icons/left-side-menu/page.svg'
import clsx from 'clsx'
import { AccountProfile } from 'components/molecules/account/accountProfile.tsx'
import { WorkingHoursProfile } from 'components/molecules/account/workingHoursProfile/index.tsx'

import css from './AccountPage.module.scss'

const leftSide: LeftSide = {
	bottomList: [
		{
			id: 1,
			image: accountSvg,
			link: '/account',
			title: 'Snaily account'
		},
		{
			id: 2,
			image: pageIcon,
			link: '/webhooks',
			title: 'Webhooks'
		}
	],
	type: 'account'
}

function onLoad() {
	const setSideBar = leftSideActions.setLeftSide(leftSide)
	store.dispatch(setSideBar)
}

const AccountPage = () => (
	<main className={clsx('main', 'app-scroll', css.root)}>
		<AccountProfile />
		<WorkingHoursProfile />
	</main>
)

export const AccountRoute: RouteObject = {
	Component: AccountPage,
	loader: onLoad,
	path: '/account'
}
